<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import { TicketsPath } from "@/path";
import Swal from "sweetalert2";
import moment from "moment";
import "vue2-datepicker/index.css";

export default {
  props: ["ticketText"],
  components: { DatePicker },
  data() {
    return {
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      bank_info: {
        acc_holder_name: "",
        acc_number: "",
        confirm_acc_number: "",
        ifsc_code: "",
        bank_name: "",
      },
      form: {
        email: "",
      },
      time: null,
      timeForm: [],
      timeslots: {
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
        Sunday: [],
      },
      notOperational: {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
        Sunday: false,
      },
      selected_request: null,
      outlet_ops: [
        {
          value: null,
          text: "Select Request",
        },
        {
          value: "request_for_time_change",
          text: "Request for time change",
        },
        {
          value: "request_to_change_bank_details",
          text: "Request to change bank Details",
        },
      ],
      apply_changes: null,
      changes_duration: [
        {
          value: null,
          text: "Apply Changes",
        },
        {
          value: "permanently",
          text: "Permanently",
        },
        {
          value: "for_selected_dates",
          text: "For Selected Days",
        },
      ],
      status: "",
      description: "",
      yourTimeValue1: [],
      yourTimeValue2: [],
      lang: {
        formatLocale: {
          months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
        },
      },
      showAccNumMismatchAlert: false,
      showReasonAlert: false,
      showApplyChangesAlert: false,
      date_range: [],
      dates_selected: [],
      actual_timings: [],
      key: 0,
    };
  },
  mounted() {
    this.getTimings();
    this.getBankDetails();
  },
  watch: {
    date_range(newDates) {
      this.dates_selected = newDates.map((date) =>
        moment(date).format("MMMM Do YYYY")
      );
    },
    selected_request() {
      this.apply_changes = null;
    },
    bank_info: {
      deep: true,
      handler() {
        if (this.bank_info.acc_number == this.bank_info.confirm_acc_number) {
          this.showAccNumMismatchAlert = false;
        }
      },
    },
    dates_selected() {
      if (!this.dates_selected.length) {
        return;
      }
      this.setTimeslots();
      if (this.apply_changes == "for_selected_dates") {
        let week_day = [];
        this.dates_selected.forEach((dateString) => {
          const date = moment(dateString, "MMMM Do YYYY");
          const dayOfWeek = date.format("dddd");
          week_day.push(dayOfWeek);
        });
        for (let key in this.notOperational) {
          if (week_day.includes(key)) {
            this.notOperational[key] = true;
          }
        }

        for (let key in this.timeslots) {
          if (!week_day.includes(key)) {
            delete this.timeslots[key];
          }
        }
      }
      this.key += 1;
      this.timeslots = this.sortDaysFromToday(this.timeslots);
      for (let key in this.timeslots) {
        if (!this.timeslots[key]) {
          delete this.timeslots[key];
        }
      }
    },
    apply_changes() {
      this.setTimeslots();
      this.dates_selected = [];
      this.date_range = [];
      this.showApplyChangesAlert = false;
      this.showReasonAlert = false;
    },
    description() {
      this.showReasonAlert = false;
    },
  },
  methods: {
    sortDaysFromToday(timeslots) {
      const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const todayIndex = new Date().getDay();

      const sortedDays = [
        ...daysOfWeek.slice(todayIndex),
        ...daysOfWeek.slice(0, todayIndex),
      ];

      let sortedTimeslots = {};

      sortedDays.forEach((day) => {
        sortedTimeslots[day] = timeslots[day];
      });

      return sortedTimeslots;
    },
    setTimeslots() {
      let actual_timings_copy = JSON.parse(JSON.stringify(this.actual_timings));
      this.timeslots = {
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
        Sunday: [],
      };
      actual_timings_copy.forEach((day) => {
        if (day.start_time) {
          let time1 = this.createDateFromTime(day.start_time);
          day.start_time = time1;
        }
        if (day.end_time) {
          let time2 = this.createDateFromTime(day.end_time);
          day.end_time = time2;
        }
        if (!day.start_time) {
          let d = day.day;
          this.notOperational[d] = true;
        }
        if (day.start_time) {
          this.timeslots[day.day].push({
            timeslot1: day.start_time,
            timeslot2: day.end_time,
          });
        }
      });
    },
    async getTimings() {
      try {
        let res = await axios.get(this.base_url + TicketsPath.FETCH_TIMINGS, {
          params: {
            res_id: this.$store.state.authfack.user.restaurant.id,
          },
        });
        if (res.data.status) {
          this.actual_timings = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    createDateFromTime(time) {
      const [hours, minutes, seconds] = time.split(":").map(Number);
      const date = new Date();
      date.setHours(hours, minutes, seconds, 0);
      return date;
    },
    async getBankDetails() {
      try {
        let res = await axios.get(this.base_url + TicketsPath.FETCH_BANK_INFO);
        if (res.data.status) {
          this.bank_info.acc_holder_name = res.data.data.acc_holder_name;
          this.bank_info.acc_number = res.data.data.acc_number;
          this.bank_info.bank_name = res.data.data.bank_name;
          this.bank_info.ifsc_code = res.data.data.ifsc_code;
        }
      } catch (e) {
        console.log(e);
      }
    },
    onSubmit(e) {
      e.preventDefault();
      if (this.bank_info.acc_number !== this.bank_info.confirm_acc_number) {
        alert("Account Numbers Do not Match");
        return;
      }
    },
    onCopy(e) {
      e.preventDefault();
    },
    newSlot(day) {
      this.timeslots[day].push({ timeslot1: null, timeslot2: null });
      this.notOperational[day] = false;
    },
    deleteSlot(day, index) {
      this.timeslots[day].splice(index, 1);
      if (this.timeslots[day].length == 0) {
        this.notOperational[day] = true;
      }
    },
    hideKeyboard() {
      Array.from(document.querySelectorAll("input")).forEach((el) => el.blur());
    },
    handleCheckbox(index, day, e) {
      this.notOperational[day] = e;
      if (this.notOperational[day]) {
        this.$set(this.timeslots, day, []);
      } else {
        this.$set(this.timeslots, day, [{ timeslot1: null, timeslot2: null }]);
      }
    },
    handleApplyAll() {
      const mondaySlots = this.timeslots.Monday.map((slot) => ({ ...slot }));
      for (let day in this.timeslots) {
        if (day !== "Monday") {
          this.$set(
            this.timeslots,
            day,
            mondaySlots.map((slot) => ({ ...slot }))
          );
        }
      }
      if (this.notOperational.Monday) {
        for (let key in this.notOperational) {
          this.notOperational[key] = true;
        }
      } else {
        for (let key in this.notOperational) {
          this.notOperational[key] = false;
        }
      }
    },
    async saveTicket() {
      let details;
      if (this.selected_request == "request_for_time_change") {
        details = {
          issue: this.selected_request,
          applyChanges: this.apply_changes,
          timeslots: this.timeslots,
          description: this.description,
        };
        if (!this.apply_changes) {
          this.showApplyChangesAlert = true;
          return;
        }
        if (!this.description) {
          this.showReasonAlert = true;
          return;
        }
      } else if (this.selected_request == "request_to_change_bank_details") {
        if (this.bank_info.acc_number != this.bank_info.confirm_acc_number) {
          this.showAccNumMismatchAlert = true;
          return;
        }
        delete this.bank_info.confirm_acc_number;
        details = {
          issue: this.selected_request,
          bank_info: this.bank_info,
        };
      }
      try {
        let res = await axios.post(this.base_url + TicketsPath.SAVE_TICKET, {
          category: "outlet_ops",
          extra_details: details,
        });
        if (res.data.status) {
          Swal.fire(
            "Successfully requested for time change",
            "",
            "success"
          ).then(() => {
            this.$router.push("/tickets_dashboard");
          });
        } else {
          throw new Error("Failed to save");
        }
      } catch (error) {
        console.log(error);
      }
    },
    isDisabledDate(date) {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      tomorrow.setHours(0, 0, 0, 0);

      if (date <= tomorrow) {
        return true;
      }

      const sevenDaysFromNow = new Date(tomorrow);
      sevenDaysFromNow.setDate(tomorrow.getDate() + 7);

      if (date > sevenDaysFromNow) {
        return true;
      }

      const disabledDates = [new Date(2019, 10, 2), new Date(2019, 10, 6)];
      for (const disabledDate of disabledDates) {
        if (
          date.getFullYear() === disabledDate.getFullYear() &&
          date.getMonth() === disabledDate.getMonth() &&
          date.getDate() === disabledDate.getDate()
        ) {
          return true;
        }
      }

      return false;
    },
    getNextDayOfWeek(dayOfWeek) {
      const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      const today = moment();
      const todayDayOfWeek = today.day();
      const targetDayOfWeek = daysOfWeek.indexOf(dayOfWeek);

      if (targetDayOfWeek === -1) {
        throw new Error("Invalid day of the week");
      }

      let daysToAdd = (targetDayOfWeek - todayDayOfWeek + 7) % 7;

      if (daysToAdd === 0 || daysToAdd === 1) {
        daysToAdd += 7;
      }

      const nextDate = today.add(daysToAdd, "days");
      return nextDate.format("MMMM Do YYYY");
    },
  },
};
</script>

<template>
  <div>
    <b-row style="color: black; font-size: 16px">
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-form-group label="Select Request:">
          <b-form-select
            v-model="selected_request"
            :options="outlet_ops"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="selected_request === 'request_for_time_change'"
      >
        <b-form-group label="Apply Changes:">
          <b-form-select
            v-model="apply_changes"
            :options="changes_duration"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="apply_changes == 'for_selected_dates'"
      >
        <b-form-group>
          <label style="font-weight: 400; font-size: 16px">Select dates:</label>
          <date-picker
            ref="datePicker-1"
            v-model="date_range"
            @focus="hideKeyboard"
            multiple
            :disabled-date="isDisabledDate"
          ></date-picker>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      v-if="apply_changes == 'for_selected_dates'"
      style="margin-bottom: 10px; color: black; font-weight: 900"
    >
      <b-col sm="8" md="6" lg="6" xl="6">
        <div style="">
          <span style="color: red"> *</span> Time changes cannot be requested
          for today and tomorrow
        </div>
      </b-col>
    </b-row>
    <b-row
      v-if="apply_changes == 'permanently'"
      style="margin-bottom: 10px; color: black; font-weight: 900"
    >
      <b-col sm="8" md="6" lg="6" xl="6">
        <div style="">
          <span style="color: red"> *</span> Time changes will be applied after
          48hrs
        </div>
      </b-col>
    </b-row>
    <b-row
      v-if="
        apply_changes == 'permanently' ||
        (apply_changes == 'for_selected_dates' && dates_selected.length)
      "
    >
      <template v-for="(daySlots, day, index) in timeslots">
        <b-col md="6" lg="4" :key="day">
          <b-card header-tag="header" footer-tag="footer">
            <template #header>
              <div>
                <h6 class="mb-0" v-if="apply_changes == 'permanently'">
                  {{ day }}
                </h6>
                <div
                  v-if="apply_changes == 'for_selected_dates'"
                  style="display: flex; gap: 30px"
                >
                  <h6 class="mb-0">{{ day }}</h6>
                  <h6 class="mb-0">{{ getNextDayOfWeek(day) }}</h6>
                </div>
              </div>
            </template>
            <div style="display: flex; justify-content: space-between">
              <template>
                <b-form-checkbox
                  :id="'close-checkbox' + index"
                  v-model="notOperational[day]"
                  :name="'close-checkbox' + index"
                  @change="handleCheckbox(index, day, $event)"
                >
                  Not operational
                </b-form-checkbox>
              </template>
              <template v-if="index == 0 && apply_changes == 'permanently'">
                <b-button
                  variant="primary"
                  @click="handleApplyAll(day)"
                  style="padding: 0px; padding-inline: 5px; border: 0px"
                >
                  Apply for all days
                </b-button>
              </template>
            </div>
            <template>
              <template v-if="daySlots.length > 0">
                <b-row>
                  <b-col cols="3"> </b-col>
                  <b-col cols="4">
                    <label> Start time </label>
                  </b-col>
                  <b-col cols="4">
                    <label> End time </label>
                  </b-col>
                </b-row>
              </template>
              <template v-for="(slotTimes, index) in daySlots">
                <b-row
                  style="align-items: end; margin-bottom: 5px"
                  :key="index"
                >
                  <b-col cols="3">
                    <h6>slot - {{ index + 1 }}</h6>
                  </b-col>
                  <b-col cols="4">
                    <date-picker
                      ref="datePicker1"
                      v-model="slotTimes.timeslot1"
                      :lang="lang"
                      type="time"
                      format="HH:mm"
                      @focus="hideKeyboard"
                    ></date-picker>
                  </b-col>
                  <b-col cols="4">
                    <date-picker
                      ref="datePicker2"
                      v-model="slotTimes.timeslot2"
                      :lang="lang"
                      type="time"
                      format="HH:mm"
                      @focus="hideKeyboard"
                    ></date-picker>
                  </b-col>
                  <b-col
                    @click="deleteSlot(day, index)"
                    cols="1"
                    style="margin-bottom: 8px; cursor: pointer"
                  >
                    <i class="fa fa-trash"></i>
                  </b-col>
                </b-row>
              </template>
            </template>
            <template>
              <b-row>
                <b-col>
                  <b-button
                    style="padding: 0px; background-color: white; border: 0px"
                    @click="newSlot(day)"
                  >
                    new slot</b-button
                  >
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-col>
      </template>
    </b-row>
    <template v-if="selected_request === 'request_to_change_bank_details'">
      <div>
        <b-form @submit="onSubmit">
          <b-row>
            <b-col sm="6" cols="10">
              <b-form-group
                id="input-group-1"
                label="Acc Holder Name :"
                label-for="name-input"
              >
                <b-form-input
                  id="name-input"
                  v-model="bank_info.acc_holder_name"
                  type="text"
                  placeholder="Enter account holder name"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6" cols="10">
              <b-form-group
                id="input-group-2"
                label="Account Number :"
                label-for="account-number-input"
              >
                <b-form-input
                  id="account-number-input"
                  v-model="bank_info.acc_number"
                  type="number"
                  placeholder="Enter account number"
                  required
                  @copy="onCopy"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6" cols="10">
              <b-form-group
                id="input-group-3"
                label="Confirm Account Number :"
                label-for="confirm-account-number-input"
              >
                <b-form-input
                  id="confirm-account-number-input"
                  v-model="bank_info.confirm_acc_number"
                  type="number"
                  placeholder="Confirm account number"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6" cols="10">
              <b-form-group
                id="input-group-4"
                label="Ifsc Code :"
                label-for="ifsc-code-input"
              >
                <b-form-input
                  id="ifsc-code-input"
                  v-model="bank_info.ifsc_code"
                  type="text"
                  placeholder="IFSC Code"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6" cols="10">
              <b-form-group
                id="input-group-5"
                label="Bank Name :"
                label-for="bank-name-input"
              >
                <b-form-input
                  id="bank-name-input"
                  v-model="bank_info.bank_name"
                  type="text"
                  placeholder="Bank Name"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </template>
    <b-row v-if="!selected_request">
      <b-col sm="8" md="6" lg="6" xl="6">
        <div
          style="
            background-color: rgb(240, 240, 240);
            border-radius: 10px;
            padding: 10px;
            font-size: 16px;
          "
        >
          Note:- <br /><br />
          Select Request for time change to see the current timings and if you
          need any changes. <br /><br />
          Select Request to change Bank details to see the current bank details
          and if you need to request for any changes.
        </div>
      </b-col>
    </b-row>
    <b-row
      style="color: black; font-size: 16px"
      v-if="
        apply_changes == 'permanently' ||
        (apply_changes == 'for_selected_dates' && dates_selected.length)
      "
    >
      <b-col sm="6">
        <b-form-group label="Reason for time change:">
          <b-form-textarea
            id="textarea"
            v-model="description"
            placeholder="Please enter the reason for time change and raise ticket"
            rows="6"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-alert v-model="showAccNumMismatchAlert" variant="danger" dismissible>
          Account number and confirm Account number does not match
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-alert v-model="showApplyChangesAlert" variant="danger" dismissible>
          Please select Apply Changes and raise ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-alert v-model="showReasonAlert" variant="danger" dismissible>
          Please enter the reason for time change
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-if="selected_request">
      <b-col>
        <b-button
          variant="primary"
          @click="saveTicket"
          style="margin-bottom: 100px"
          >{{
            selected_request == "request_for_time_change"
              ? "Request for time change"
              : "Request to change Bank Details"
          }}</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>
<style>
.mx-input {
  padding-block: 0px !important;
}
.col-4 {
  padding-inline: 4px !important;
}
.btn-secondary {
  color: blue !important;
}
</style>
